<template>
  <div class="resultDialog">
    <!-- <div class="container"> -->
    <el-dialog
      title="项目详情"
      :visible.sync="visible"
      :before-close="handleClose"
      :fullscreen="isfullscreen"
      custom-class="customWidth"
      class="dialog_reslt"
    >
      <p class="fullscreen" @click="fullscreen" v-show="!isfullscreen">
        <img src="../../assets/Home/全屏.png" alt />
      </p>
      <p class="fullscreen" @click="fullscreen" v-show="isfullscreen">
        <img src="../../assets/Home/组 23577.png" alt />
      </p>
      <div class="top">
        <div class="videoTitle">
          <h3>{{ inforesdia.Title }}</h3>

          <el-popover placement="left-start" width="200" trigger="click">
            <div class="qrcodeBox" ref="qrcodeBox">
              <div id="qrcode"></div>
              <p>请使用微信扫描二维码</p>
            </div>

            <el-button slot="reference" type="text">
              <p>
                <span @click="showecode">
                  <img src="../../assets/Home/分享 (1).png" alt />
                  分享至手机
                </span>
              </p>
            </el-button>
          </el-popover>

          <p>
            <span id="copylink" @click="copylink">
              <img src="../../assets/Home/KHCFDC_复制.png" alt />
              复制分享链接
            </span>
          </p>
        </div>
        <div class="parentBtn">
          <ul class="descInf">
            <li>单位名称：{{ inforesdia.CompanyOrPersonName }}</li>
            <li>技术领域：{{ inforesdia.TechFieldEnum }}</li>
            <li>拟投资金额：{{ inforesdia.InvestInFunds=="0"?"面议":inforesdia.InvestInFunds+"万元" }}</li>
            <li>合作方式：{{ inforesdia.ModeOfCooperation }}</li>
          </ul>
          <div class="btn">
            <el-button type="primary" id="btn1" v-show="!iscollection" @click="colect">
              <img src="../../assets/Home/路径 9161@2x.png" alt />
              收藏
            </el-button>
            <el-button type="primary" id="btn2" v-show="iscollection" @click="colect">
              <img src="../../assets/Home/路径 916.png" alt />
              已收藏
            </el-button>
            <el-button type="primary" @click="toDocking">
              <img src="../../assets/Home/分组 39@2x.png" alt />
              我要对接
            </el-button>
          </div>
        </div>
      </div>
      <el-tabs type="border-card" :stretch="true">
        <el-tab-pane label="项目简介">
          <!-- 没数据 -->
          <empty v-if="showEmptyT"></empty>
          <!-- 有数据 -->
          <div v-html="inforesdia.DetailsOfTheResults" v-else class="content"></div>
        </el-tab-pane>
        <el-tab-pane label="项目图片" class="resultimg">
          <!-- 没数据 -->
          <empty v-if="showEmptyI"></empty>
          <!-- 有数据 -->

          <div class="imgs" v-else>
            <el-carousel indicator-position="outside" arrow="never" ref="fruit" :autoplay="true">
              <el-carousel-item v-for="(i, n) in imgsUrl" :key="n" class="imgItem">
                <img :src="i" alt />
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- <div v-else class="imgs"> -->

          <!-- <div v-for="(item, n) in imgsUrl" class="imgItem">
              <img :src="item" alt="" />
          </div>-->

          <!-- </div> -->
        </el-tab-pane>
        <el-tab-pane label="项目视频">
          <!-- 没数据 -->
          <empty v-if="showEmptyV"></empty>
          <!-- 有数据 -->
          <div v-else>
            <video
              :src="infovideo"
              class="resultvideo"
              :controls="flag"
              @ended="videoOver"
              @pause="videoPause"
              @play="videoP"
              ref="videoPlay"
            ></video>
            <img ref="play" src="../../assets/Home/视频播放.png" alt class="play" @click="onPlay" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="留言对接">
          <!-- 暂无数据 -->
          <empty v-if="showEmpty"></empty>
          <!-- 有数据 -->
          <div class="DockingList" v-else>
            <div class="msgContent" v-for="(item, index) in msgList" :key="item.ID">
              <div class="lis">
                <div class="LeftInfo">
                  <img src="../../assets/Home/组 4218.png" alt />
                  <div class="Left-R">
                    <p class="pname">{{ formatName(item.RealName) }}</p>
                    <p class="p-border">{{ item.Content }}</p>
                  </div>
                </div>
                <div class="RightTime">{{ item.createtime.substring(0, 10) }}</div>
              </div>
              <!-- 点赞评论， -->
              <ul class="commentList">
                <li v-for="(i, n) in coo[index]">
                  <p>
                    <span class="commentName">{{ i.RealName }} ：</span>
                    <span class="commentText">{{ i.Content }}</span>
                  </p>
                  <p class="commentTime">{{ i.createtime.substring(0, 10) }}</p>
                </li>
              </ul>
              <div class="islike">
                <p class="comment" @click="comment(item.ID)">
                  <img src="../../assets/images/组 24783@2x.png" alt />
                  <span>评论</span>
                </p>
                <!-- 点赞状态 -->
                <p v-if="item.Is == 'Y'" @click="liked(item, index)" class="goodjob">
                  <img src="../../assets/images/组 247866@2x.png" alt />
                  <span>{{ item.r }}</span>
                </p>
                <!-- 未点赞状态 -->
                <p v-else class="goodjob" @click="liked(item, index)">
                  <img src="../../assets/images/组 24786@2x.png" alt />
                  <span>{{ item.r }}</span>
                </p>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 我要对接的弹框 -->
    <Docking
      v-if="rDialogVisible"
      :DialogVisible.sync="rDialogVisible"
      :id="ProjectID.toString()"
      :type="type"
      :ParentId="ParentId"
    ></Docking>
  </div>
  <!-- </div> -->
</template>

<script>
import {
  cloudSelect,
  colect,
  imgcommonUrl,
  dockingList,
  Docking1,
} from '../../api/url'
import { postAction, getAction } from '../../api/api'
//生成二维码
import QRCode from 'qrcodejs2'
import Clipboard from 'clipboard'

import Docking from '@/components/Docking.vue'
import Empty from '../../components/empty.vue'
// import func from "vue-editor-bridge";
export default {
  props: { ID: { Type: Number }, isVisible: { type: Boolean } },
  components: { Docking, Empty },
  data() {
    return {
      showBox: false,
      flag: false,
      inforesdia: '',
      visible: this.isVisible,
      visible: true,
      infovideo: '',

      isfullscreen: false,
      ProjectID: this.ID,
      UserID: 0,
      RealName: '',
      rDialogVisible: false,
      type: '4',
      iscollection: 0,
      DockingList: [
        {
          src: require('../../assets/Home/组 4218.png'),
          name: '王**',
          title:
            '世界能源和环境问题的日益严峻使人类对可再生能源和清洁能源的利用空 前关注，太阳能的热利用便是可再生能源利用的良好途径',
        },
        {
          src: require('../../assets/Home/组 4218.png'),
          name: '王**',
          title:
            '世界能源和环境问题的日益严峻使人类对可再生能源和清洁能源的利用空 前关注，太阳能的热利用便是可再生能源利用的良好途径',
        },
        {
          src: require('../../assets/Home/组 4218.png'),
          name: '王**',
          title:
            '世界能源和环境问题的日益严峻使人类对可再生能源和清洁能源的利用空 前关注，太阳能的热利用便是可再生能源利用的良好途径',
        },
      ],
      showEmpty: false,
      showEmptyT: false,
      showEmptyI: false,
      showEmptyV: false,
      imgsUrl: [],
      msgList: [],
      ParentId: 0,
      shatwon: [],
      coo: [],
    }
  },

  created() {
    //// console.log("成果详情页的ID", this.ID);
    // //// console.log("this.isVisible", this.isVisible);
    //// console.log("created用户id", localStorage.getItem("RealID"));
    this.UserID = localStorage.getItem('RealID')
    // this.RealName = localStorage.getItem("RealName");
    // 第一次
    this.loadResultDialog()
    // 对接列表
    this.getMessage()
  },
  mounted() {
    // 生成二维码
    // this.getCoed();
    let that = this
    // //// console.log("idid",id)
    // this.$router.push("/resultDialogCopy");
    var isCopy = new Clipboard('#copylink', {
      text: function () {
        let id = that.ID
        //// console.log(id);
        // 待更正

        // return 'http://localhost:9999/#' +'/resultDialogCopy'+ '?id='+ id;
        return (
          imgcommonUrl + '/cement/index.html#/resultDialogCopy' + '?id=' + id
        )
        // return imgcommonUrl +'/resultDialogCopy'+ '?id='+ id;
      },
    })
    isCopy.on('success', function (e) {
      //// console.log(e);
    })

    this.$bus.$on('LoginSuccess', (e) => {
      // //// console.log(e);
      if (e) {
        setTimeout(() => {
          this.UserID = localStorage.getItem('RealID')
          this.loadResultDialog()
        }, 400)

        //// console.log("eeee是否收藏", this.iscollection);
      }
    })
  },
  methods: {
    // 加载成果厅详情页
    loadResultDialog() {
      let data = {
        action: 'Get_AchievementsInfo',
        id: this.ID,
        userid: this.UserID,
      }
      //// console.log("loadResultDialog", this.UserID);
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        //// console.log("成果厅详情页", res);
        // 视频
        if (res.videoUrl == '') {
          this.showEmptyV = true
        } else {
          this.showEmptyV = false
        }
        // 图片
        if (res.imgsUrl == '') {
          this.showEmptyI = true
        } else {
          this.showEmptyI = false
        }
        // 简介
        if (res.DetailsOfTheResults == '') {
          this.showEmptyT = true
        } else {
          this.showEmptyT = false
        }
        this.inforesdia = res
        this.imgcommonUrl = imgcommonUrl
        //// console.log(imgcommonUrl,"imgcommonUrl")
        this.imgsUrl = res.imgsUrl.split('|')
        //// console.log("图片地址", res.imgsUrl.split("|"));
        this.infovideo = res.videoUrl
        // this.infovideo = imgcommonUrl + res.videoUrl;
        this.iscollection = res.iscollection
        //// console.log("是否收藏", res.iscollection);
      })
    },
    handleClose(done) {
      this.visible = false
      this.$emit('update:isVisible', false)
      //// console.log(this.visible);
      // this.$router.go(-1);
    },
    // 详情页全屏
    fullscreen() {
      this.isfullscreen = !this.isfullscreen
    },
    // 点击收藏
    colect() {
      let RealName = localStorage.getItem('RealName')
      if (RealName == '') {
        let vm = this
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        this.addColection()
      }
    },
    //添加收藏
    addColection() {
      let a = localStorage.getItem('RealID')
      //// console.log("a", a);
      let data = {
        action: 'Collection_Items',
        UserID: a,
        Type: '7',
        ProjectID: this.ID,
      }
      postAction(colect, this.$qs.stringify(data)).then((res) => {
        // //// console.log("收藏返回的res", res);
        this.$message({
          message: res.info,
          type: 'success',
        })
        this.loadResultDialog()
      })
    },

    // 我要对接
    toDocking() {
      let RealName = localStorage.getItem('RealName')
      let vm = this

      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.rDialogVisible = true
        //// console.log("点击了我要对接");
        //// console.log("我要对接的ProjectID", this.ProjectID);
        //// console.log("this.DialogVisible", this.rDialogVisible);
      }
    },
    // 分享至手机
    showecode() {
      //// console.log("分享至手机");
      this.getCoed()
    },
    getCoed() {
      //// console.log("生成二维码");
      document.getElementById('qrcode').innerHTML = ''
      let qrcode = new QRCode('qrcode', {
        width: 180, // 宽
        height: 180, // 高
        // text: "http://localhost:9999/#/SharePage?type=1&id=" + this.ID, // 二维码内容,也可以直接放接口获取的数据
        text:
          imgcommonUrl + '/cement/index.html#/SharePage?type=1&id=' + this.ID, // 二维码内容,也可以直接放接口获取的数据
        render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      })
      //// console.log(qrcode);
    },

    // 复制分享链接
    copylink() {
      //// console.log("点击了复制链接");
      // //// console.log(window.location.href);
      this.$message({
        message: '已复制分享链接',
        customClass: 'messageBox1',
        // duration: 0,
        iconClass: '0',
      })
    },
    // 加载留言对接列表
    // loadDockingList() {
    //   this.UserID = localStorage.getItem("RealID");
    //   //// console.log("留言对接的uid", this.UserID);
    //   let data = {
    //     action: "Get_TechFieldList",
    //     sort: "DESC",
    //     uid: this.UserID,
    //     projId: this.ProjectID,
    //   };
    //   postAction(dockingList, this.$qs.stringify(data)).then((res) => {
    //     //// console.log("对接列表返回的", res);
    //     this.DockingList = res;
    //     if (res.length == 0) {
    //       this.showEmpty = true;
    //     } else {
    //       this.showEmpty = false;
    //     }
    //   });
    // },
    //获取对接列表
    getMessage() {
      let data = {
        action: 'UserLeaveList',
        UserID: localStorage.getItem('userId'),
        // UserID:1,
        projectid: this.ProjectID,
        // projectid: 74497,
        type: '4',
        pageIndex: '1',
        pageSize: '10',
        // ParentId:'0',
        ParentId: 0,
      }
      getAction(Docking1, data).then((res) => {
        //// console.log(res);
        this.msgList = res.list
        if (res.list.length == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        res.list.forEach((item, index) => {
          if (item.r == null) {
            item.r = 0
          }
          let b = {
            action: 'UserLeaveList',
            pageIndex: 1,
            pageSize: '',
            projectid: this.ProjectID,
            // projectid: 74497,
            type: '4',
          }
          b.ParentId = item.ID

          ////// console.log(b);
          getAction(Docking1, b).then((res) => {
            //// console.log("评论内容", res);
            this.shatwon = res.list

            if (this.coo.length == index) {
              this.coo.push(this.shatwon)
            }
          })
        })
      })
    },

    // 点赞
    liked(a, index) {
      let RealName = localStorage.getItem('RealName')
      //// console.log("RealName", RealName);

      if (RealName == '' || RealName == null) {
        let vm = this
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        //// console.log(a);
        // this.islikeflag = !this.islikeflag;
        // //// console.log(this.islikeflag)
        let data = {
          action: 'Support',
          userid: localStorage.getItem('userId'),
          // userid:1,
          projectid: a.ID,
        }
        postAction(Docking1, this.$qs.stringify(data)).then((res) => {
          //// console.log(res);
          let data = {
            action: 'UserLeaveList',
            UserID: localStorage.getItem('userId'),
            // UserID:1,
            projectid: this.ProjectID,
            // projectid: 74497,
            type: '4',
            pageIndex: '1',
            pageSize: '10',
            // ParentId:'0',
            ParentId: 0,
          }
          getAction(Docking1, data).then((res) => {
            //// console.log(res);
            //// console.log(index);
            if (this.msgList[index].Is == 'Y') {
              this.msgList[index].r -= 1
            } else {
              this.msgList[index].r += 1
            }

            this.msgList[index].Is = res.list[index].Is
          })
        })
      }
    },
    //评论
    comment(a) {
      //// console.log(a); //列表的ID
      this.ParentId = Number(a)

      let RealName = localStorage.getItem('RealName')
      let vm = this

      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.rDialogVisible = true
        //// console.log("需求详情我要对接的ProjectID", this.ProjectID);
        // //// console.log("点击了yunDetail我要对接")
        // //// console.log('this.DialogVisible',this.dDialogVisible)
      }
    },
    onPlay() {
      this.$refs.videoPlay.play()
      this.$refs.play.style.display = 'none'
      this.flag = true
    },
    videoOver() {
      this.$refs.play.style.display = 'block'
      this.flag = false
    },
    videoPause() {
      this.$refs.play.style.display = 'block'
    },
    videoP() {
      this.$refs.play.style.display = 'none'
    },
    formatName(name) {
      let newStr
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*'
      } else if (name.length > 2) {
        if (
          name.indexOf('学院') != -1 ||
          name.indexOf('大学') != -1 ||
          name.indexOf('研究院') != -1 ||
          name.indexOf('中心') != -1 ||
          name.indexOf('联盟') != -1
        ) {
          newStr = name
        } else {
          let char = ''
          for (let i = 0, len = name.length - 2; i < len; i++) {
            char += '*'
          }
          newStr = name.substr(0, 1) + char + name.substr(-1, 1)
        }
      } else {
        newStr = name
      }

      return newStr
    },
  },
}
</script>
<style lang="scss" scoped>
.resultDialog {
  font-size: 1rem;
  background: linear-gradient(94deg, #035fd0 0%, #257aeb 100%);
  /* height: 50rem; */
}
/* .container {
  /* width: 93.75rem; */
/* height: 50rem;
  background: url("../../assets/Home/1@2x.png");
  background-size: 100% 100%; */
.parentBtn {
  position: relative;
}
.fullscreen {
  position: absolute;
  margin-right: 1.75rem;
  top: 2rem;
  right: 4rem;
  img {
    width: 1.55rem;
  }
}
.videoTitle {
  display: flex;
  margin-top: 1.875rem;
  position: relative;
  /* line-height: 1; */
  color: #0a0a0a;
  vertical-align: middle;
  font-family: Microsoft YaHei;
  justify-content: space-between;
  /deep/.el-button--text {
    position: absolute;
    top: 0.1rem;
    right: 11.25rem;
    color: #2769dc;
    font-size: 1rem;
    padding: 0 1.25rem;
  }
  img {
    vertical-align: middle;
  }
}

.videoTitle > h3 {
  font-size: 2rem;
  font-weight: bold;
}
.videoTitle > p {
  cursor: pointer;
  float: right;
  margin-right: -2.1875rem;
  color: #2769dc;
}
.videoTitle > p > span {
  margin-right: 2.875rem;
  font-size: 1rem;
  img {
    vertical-align: middle;
  }
}
.descInf {
  width: 69.625rem;
  text-align: left;
  margin: 1.25rem 0 2.5rem 0;
}
.descInf > Li {
  margin-bottom: 0.625rem;
  display: inline-block;
  font-size: 1rem;
  color: #999;
  margin-right: 2.5rem;
}

.btn {
  margin-left: 0.625rem;
  position: absolute;
  top: 0;
  right: 0;
  img {
    width: 1.25rem;
  }
  #btn1 {
    background: #ff9e57;
    border: 0.0625rem solid #ff9e57;
    color: #ffffff;
  }
  #btn2 {
    border: 0.0625rem solid #ff9e57;
    background: #ffffff;
    color: #ff9e57;
  }
  /deep/.el-button {
    padding: 0;
  }
  .el-button--primary {
    /* margin-top: -1.586667rem; */
    border-color: #2769dc;
    background: #2769dc;

    width: 7.9375rem;
    height: 2.8125rem;
    /* font-size: 17px; */
    font-size: 1.225rem;
    // width: 3.2rem;
    // height: 1.2rem;
    img {
      vertical-align: middle;
    }
  }
}
/* } */
/deep/ .customWidth {
  width: 93.75rem;
}
/deep/ .dialog_reslt .el-dialog {
  /* width: 93.75rem; */

  /* height: 50rem; */
  /* margin-top: 5rem !important; */
  .el-dialog .is-fullscreen {
    width: 100% !important;
  }
  .el-dialog__header {
    padding: 2.675rem;
    position: relative;
    .el-dialog__headerbtn {
      width: 1.375rem;
      height: 1.375rem;
      position: absolute;
      top: 2rem;
      right: 1.875rem;
      background: url('../../assets/Home/关  闭 (1) (1).png') no-repeat center;
      i {
        visibility: hidden;
      }
    }
  }
  .el-dialog__body {
    padding: 0.625rem 2.5rem 3rem 2.5rem;
    font-size: 1rem;
  }
  .el-dialog__wrapper {
    top: -2rem;
  }
  .el-dialog__title {
    padding: 0.5rem;
    background: url('../../assets/Home/组 23133.png') no-repeat bottom;
    float: left;
    font-size: 1.75rem;
  }
  .el-tabs__item {
    font-size: 1.25rem;
    color: #333333;
  }
  .resultimg {
    width: 41.75rem;
    /* height: 23.5625rem; */
    text-align: center;
    margin: 2.25rem auto;
    .imgs {
      .el-carousel__container {
        width: 668px;
        height: 337px;
        .imgItem {
          img {
            // max-width: 41.75rem;
            // max-height: 41.75rem;
            width: 668px;
            height: 337px;
          }
        }
      }
    }
  }
  .resultvideo {
    /* width: 703px; */
    height: 18.875rem;
    text-align: center;
    position: relative;
  }
  .play {
    width: 5rem;
    position: absolute;
    top: 38%;
    left: 47%;
    z-index: 999999;
  }
}
.content {
  text-align: left;
}

/* .el-tabs{
  min-height: 37.5rem !important;
} */
/deep/.el-tabs--border-card {
  font-family: Microsoft YaHei;
}

/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #333333;
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  border-top: 3px solid #2769dc;
  color: #2769dc;
  font-size: 1.25rem;
  font-weight: bold;
}
.DockingList {
  margin-top: 2.375rem;
  margin-left: 2.125rem;
  margin-right: 2.375rem;
  font-size: 1rem;
  /* 分割线 */
  /deep/.el-divider--horizontal {
    margin-top: 0;
    margin-left: 4.1875rem;
    width: 93%;
    margin-bottom: 1.3125rem;
  }
  .lis {
    display: flex;
    /* height: 5.0625rem; */
    justify-content: space-between;
    .RightTime {
      margin-top: 1.5625rem;
      color: #999999;
    }
  }

  .LeftInfo {
    display: flex;
    color: #666666;
    img {
      width: 3.625rem;
      height: 3.625rem;
      vertical-align: middle;
      margin-right: 1rem;
    }
    .Left-R {
      text-align: left;
      .pname {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        /* line-height: 24px; */
        color: #333333;
      }
      .p-border {
        width: 64.3125rem;
        margin-top: 0.5rem;
        padding-bottom: 1.5625rem;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        /* line-height: 21px; */
        color: #666666;
      }
    }
  }
}
.commentName {
  color: #2a3457;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.commentTime {
  margin-top: 0.5rem;
}
.commentText {
  color: #9fa3b3;
}
.qrcodeBox {
  width: 13.75rem;
  height: 18.25rem;
  margin-top: 0.625rem;
  border-radius: 0.625rem;
  #qrcode {
    margin-bottom: 1.125rem;
    margin-left: 0.625rem !important;
  }
  p {
    text-align: center;
    color: #999999;
  }
}
.commentList {
  width: 72.625rem;
  margin: 0 auto;
  text-align: left;
  li {
    background: rgba(249, 249, 249, 0.39);
    margin-bottom: 1.25rem;
  }
}
.islike {
  display: flex;
  margin-left: 4.55rem;
  margin-bottom: 1.25rem;
  .goodjob {
    img {
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
  .comment {
    margin-right: 21px;
    img {
      vertical-align: middle;
      width: 14px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.messageBox1 {
  justify-content: center;
  font-size: 1.125rem;
  opacity: 0.8;
  top: 28.375rem !important;
  border: 1px solid #707070;
  border-radius: 16px !important;
  background: #333333 !important;
  min-width: 13.75rem !important;
  height: 5rem !important;
  color: #ffffff;
  .el-message__content {
    text-align: center;
    font-size: 1.125rem;
  }
}
</style>